import { type GroupProps } from '~/components/component-library/Group/types'

export const GroupFooter = ({ footer }: { footer?: GroupProps['footer'] }) => {
  return <div className="text-xs text-secondary">{footer}</div>
}
